import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';

import { UniformeRouteModule } from './spyral-routing.module'
import { PrendaComponent } from './views/prenda/prenda.component';
import { TallaGrupoPrendaComponent } from './views/talla-grupo-prenda/talla-grupo-prenda.component';
import { CupoPrendaEmpleadoComponent } from './views/cupo-prenda-empleado/cupo-prenda-empleado.component';
import { DotacionUniformeComponent } from './views/dotacion-uniforme/dotacion-uniforme.component';
import { DataLdapComponent } from './views/data-ldap/data-ldap.component';
import { AplicacionComponent } from './views/baja_usuario/aplicacion/aplicacion.component';
import { AplicacionUsuarioComponent } from './views/baja_usuario/aplicacion-usuario/aplicacion-usuario.component';
import { ParametroInicialComponent } from './views/parametro-inicial/parametro-inicial.component';


@NgModule({
    declarations: [
        ParametroInicialComponent,
        PrendaComponent,
        TallaGrupoPrendaComponent,
        CupoPrendaEmpleadoComponent,
        DotacionUniformeComponent,
        DataLdapComponent,
        AplicacionComponent,
        AplicacionUsuarioComponent
    ],

    exports: [
      ParametroInicialComponent,
      PrendaComponent,
      TallaGrupoPrendaComponent,
      CupoPrendaEmpleadoComponent,
      DotacionUniformeComponent,
      DataLdapComponent,
      AplicacionComponent,
      AplicacionUsuarioComponent
    ],
    imports: [
      UniformeRouteModule,
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
export class SypralModule {}